import React, { useState, useEffect, useMemo, useContext, useCallback } from 'react'
import { useTranslation } from "react-i18next"
import { Dialog, Typography } from '@material-ui/core';
import { GetAlertsComponent, setObjectByPath} from "./utils"
import _ from 'lodash'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import DeleteIcon from '@mui/icons-material/Delete';
import TimeDeltaTextField from './Components/TimeDeltaTextField';
import RulesContext from "../../../../context/rules-context"
import Button from '@material-ui/core/Button';
import {
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material'

export const allFilters = [
        {type:'status',            operator: "must"},
        {type:'keyword',           operator: "must"},
        {type:'polarity',          operator: "must"},
        {type:'court_type',        operator: "must"},
        {type:'process_type',      operator: "must"},
        {type:'secret_of_justice', operator: "must"},
        {type:'publication_date',  operator: "younger_than"},
        {type:'last_update',       operator: "younger_than"},
        {type:'status',            operator: "must_not"},
        {type:'keyword',           operator: "must_not"},
        {type:'polarity',          operator: "must_not"},
        {type:'court_type',        operator: "must_not"},
        {type:'process_type',      operator: "must_not"}
    ]

export const limitExceededActionOptions = ['continue', 'automatically_reprove', 'send_to_manual_analysis']

export function ProcessesBox (props) {
    const { t } = useTranslation()
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    return (
        <div>
            {!read_only ?
                <div style={{display:"flex", alignItems: "center"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("Processos")}
                        {(node.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null}
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t("Processos")}
                    </div>
                </div>
            }
        </div>
    )
}


export function ProcessesConfiguration(props){
    const { t } = useTranslation()
    let { read_only } = props
    let { handleConfigurationClose } = props
    let { handleNodeChange } = props
    let { node } = props
    let rulesList = useContext(RulesContext)

    const [errors, setErrors] = useState([])
    const [open, setOpen] = useState(true)
    const [nodeState, setNodeState] = useState(node)
    const [activeFilters, setActiveFilters] = useState(() => {
        const filters = node.node.properties.filters ?? {}

        return Object.entries(filters).flatMap(([type, operators]) =>
            Object.keys(operators).map(op => ({
                type: type,
                operator: op
            }))
        )
    })
    const [confirmExitOpen, setConfirmExitOpen] = useState(false)

    const availableFilters = useMemo(() => {
        const seenTypes = new Set()
        return (allFilters.filter((filter) =>{
                    const isInList = seenTypes.has(filter.type)
                    const isActive = activeFilters.some((activeFilter) => activeFilter.type === filter.type && activeFilter.operator === filter.operator)
                    if(!isInList && !isActive) {
                        seenTypes.add(filter.type)
                        return true
                    }
                    else
                        return false
                }
            )
            .sort((a,b) => (a.type < b.type)? -1 : (a.type === b.type)? 0 : 1)
        )
    }, [activeFilters])

    useEffect(() => {
        setNodeState(node)
    }, [node])

    const handleSave = () => {
        handleConfigurationClose()
        handleNodeChange(nodeState)
    }

    const handleAttemptClose = () => {
        if(read_only){
            handleClose()
        }
        else {
            setConfirmExitOpen(true)
        }
    }

    const handleClose = () => {
        handleConfigurationClose()
        setOpen(false)
    }

    const handleAddFilter = () => {
        const filterChoose = {
            type: 'choose',
            operator: 'choose'
        }
        setActiveFilters((prev) => [...prev, filterChoose])
    }

    const filterProps= {
        nodeState:nodeState,
        setNodeState:setNodeState,
        activeFilters:activeFilters,
        setActiveFilters:setActiveFilters,
        availableFilters:availableFilters,
        setErrors: setErrors,
        read_only: read_only
    }
    const hasErrors = errors && errors.length > 0
    return(
        <>
        <Dialog
        open={open}
        onClose={handleAttemptClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{style:{padding: "20px 25px"}}}
        >
            <div style={{display: "flex", marginBottom:"12px", justifyContent: "space-between"}}>
                <span className={["blueText", "titleSize"].join(" ")}>{t(node.node.description)}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>
                    <HelpIcon style={{fontSize: "16px", marginTop:"5px"}}/>
                </Tooltip>
            </div>
            <SelectLimitExceededAction
                read_only={read_only}
                nodeState={nodeState}
                setNodeState={setNodeState}
                setErrors={setErrors}
            />
            {activeFilters.map(filter => {
                let element
                let key = filter.type + filter.operator
                switch(filter.type) {
                    case "choose":
                        element = <ChooseFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "polarity":
                        element = <PolarityFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "court_type":
                        element = <CourtTypeFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "status":
                        element = <StatusFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "process_type":
                        element = <ProcessTypeFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "keyword":
                        element = <KeywordFilter
                        currentFilter={filter}
                        rulesList={rulesList}
                        {...filterProps}
                        />
                        break
                    case "last_update":
                        element = <LastUpdateFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "publication_date":
                        element = <PublicationDateFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    case "secret_of_justice":
                        element = <SecretOfJusticeFilter
                        currentFilter={filter}
                        {...filterProps}
                        />
                        break
                    default:
                }
                return(<div key={key} className='boxConfigDialogSection'>
                    {element}
                </div>)
            })}
            {!read_only &&
             !(activeFilters.some(filter => filter.type === 'secret_of_justice')) &&
             !(activeFilters.some(filter => filter.type === 'choose')) &&
             (activeFilters.length < allFilters.length) &&
             <div style={{margin:"5px 0 12px 0", display:"flex", justifyContent:"center"}}> <div
                style={{cursor:"pointer", textAlign:"center", width:"80%"}}
                onClick={handleAddFilter}
                className={"blueText"}
                >
                    {t("+ ADICIONAR FILTRO")}
                </div>
            </div>}
            <div style={{display:"flex", margin: "12px auto 0 auto"}}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{width:"120px"}}
                    onClick={handleConfigurationClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only && <Tooltip
                    title={hasErrors? <div className="tooltipText"><ul>{errors.map((error, index) => (<li key={index}>{t(error.message)}</li>))}</ul></div>: ""}
                >
                    <div
                        className={["button", "standard", "normalText", "normalMediumSize", hasErrors ? "disabled" : "" ].join(" ")}
                        style={{ width: "120px" }}
                        onClick={hasErrors ? null : handleSave}
                    >
                        {t("save")}
                    </div>
                </Tooltip>}
            </div>
        </Dialog>
        {confirmExitOpen && <Dialog
            open={confirmExitOpen}
            onClose={() => setConfirmExitOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {t("Tem certeza que deseja fechar?")}
            </DialogTitle>
            <DialogContent>
                <Typography id="alert-dialog-description">
                    {t("Você perderá os dados novos/alterados. Deseja continuar?")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setConfirmExitOpen(false)}
                        className="button onlyboarder normalText normalMediumSize">
                    {t("Não, continuar editando")}
                </Button>
                <Button onClick={handleClose}
                        className="button standard normalText normalMediumSize">
                    {t("Sim, fechar")}
                </Button>
            </DialogActions>
        </Dialog>}
        </>
    )
}

function SelectLimitExceededAction(props){
    const { t } = useTranslation()
    const { read_only } = props
    const { setErrors } = props
    const { nodeState } = props
    const { setNodeState } = props

    const [action, setAction] = useState(nodeState.node.properties.limit_exceeded_action)
    const isWrong = useMemo(()=> !action || !limitExceededActionOptions.includes(action), [action])

    useEffect(() => {
        const error = {
            type: 'limit_exceeded',
            operator: 'limit_exceeded',
            message:t("A ação ao atingir o tamanho máximo de análise deve ser especificada")
        }
        if(isWrong)
            setErrors((prev) => [...prev, error])
        else
            setErrors((prev) => prev.filter((err) => !(err.type === error.type && err.operator === error.operator)))
    }, [isWrong, setErrors, t])

    const handleLimitExceededActionChange = (e, newValue) => {
        setAction(newValue)

        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node,"properties.limit_exceeded_action", newValue)
        setNodeState(new_node)
    }

    return (
        <div className="boxConfigDialogSection">
            <div
                className={["blueText", "dialogInfoSize"].join(" ")}
                style={{ cursor: "pointer", textAlign: "left", width: "80%", fontSize: "16px"}}
            >
                {t("Ao atingir o número máximo de processos analisados:")}
            </div>
            <Autocomplete
                options={limitExceededActionOptions}
                value={action || null}
                onChange={handleLimitExceededActionChange}
                getOptionLabel={(option) => t(option)}
                disableClearable
                size="small"
                readOnly={read_only}
                fullWidth
                style={{ width: "80%", margin: "3px auto" }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        className="filterTextbox"
                        style={{ textAlign: "center" }}
                        error={isWrong}
                    />
                )}
            />
        </div>
    )
}

function ChooseFilter(props){
    const { t } = useTranslation()
    return(<> <div
        style={{cursor:"pointer", textAlign:"left", width:"80%"}}
        className={["blueText", "dialogInfoSize"].join(" ")}
        >
            {t("Filtrar por:")}
        </div>
        <ChooseFilterSection {...props}/>
        </>)
}

function PolarityFilter(props) {
    const { nodeState } = props
    const { currentFilter } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [polarities, setPolarities] = useState(nodeState.node.properties.filters?.[filterType]?.[operator] || [])

    const autocompleteProps = {
        options:['active','neutral','passive'],
        limitTags: 2,
        multiple:true,
        disableCloseOnSelect: true,
        value:polarities
    }
    return <AutocompleteFilter
            {...props}
            multipleOperators={true}
            setValueState={setPolarities}
            autocompleteProps={autocompleteProps}
        />
}

function StatusFilter(props) {
    const { nodeState } = props
    const { currentFilter } = props
    const { setActiveFilters } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [status, setStatus] = useState(nodeState.node.properties.filters?.[filterType]?.[operator] || [])

    const becomeSecretOfJusticeFilter = useCallback(() => {
        setActiveFilters((prev) => prev.map((filter) => {
            if(filter.type === currentFilter.type && filter.operator === currentFilter.operator) {
                return { type: 'secret_of_justice', operator: "must" }
            }
            return filter
        }))
    }, [setActiveFilters, currentFilter.type, currentFilter.operator])

    useEffect(() => {
        if (status[0] === "DADOS OCULTADOS: SEGREDO DE JUSTIÇA") {
            becomeSecretOfJusticeFilter()
        }
    }, [status, becomeSecretOfJusticeFilter])

    if (status[0] === "DADOS OCULTADOS: SEGREDO DE JUSTIÇA") {
        return <SecretOfJusticeFilter
                    {...props}
                    currentFilter={{ type: 'secret_of_justice', operator: "must" }}
                />
    }

    const transformToUppercase = (newValue) => {
        const uppercasedValues = newValue.map(value =>
            (typeof value === 'string' ? value.toUpperCase() : value)
        )
        return uppercasedValues
    }

    const autocompleteProps = {
        options:['APENSO', 'ARQUIVADO', 'ATIVO', 'AUTUADO',
                 'BAIXADO', 'DECIDIDO', 'DISTRIBUIDO',
                 'EM GRAU DE RECURSO', 'ENCERRADO', 'EXECUCAO',
                 'EXTINTO', 'FINALIZADO', 'INDEFINIDO', 'JULGADO',
                 'REDISTRIBUIDO', 'SUSPENSO', 'TRANSITADO EM JULGADO'],
        limitTags: 2,
        multiple:true,
        disableCloseOnSelect: true,
        value: status
    }
    return <AutocompleteFilter
            {...props}
            multipleOperators={true}
            transformInput={transformToUppercase}
            setValueState={setStatus}
            autocompleteProps={autocompleteProps}
        />
}

function ProcessTypeFilter(props) {
    const { nodeState } = props
    const { currentFilter } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [processTypes, setProcessTypes] = useState(nodeState.node.properties.filters?.[filterType]?.[operator] || [])
    const transformToUppercase = (newValue) => {
        const uppercasedValues = newValue.map(value =>
            value.toUpperCase()
        )
        return uppercasedValues
    }

    const autocompleteProps = {
        freeSolo: true,
        open:false,
        limitTags: 2,
        multiple:true,
        value: processTypes
    }
    return <AutocompleteFilter {...props}
                multipleOperators={true}
                transformInput={transformToUppercase}
                setValueState={setProcessTypes}
                autocompleteProps={autocompleteProps}
            />
}

function CourtTypeFilter(props) {
    const { nodeState } = props
    const { currentFilter } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [courtTypes, setCourtTypes] = useState(nodeState.node.properties.filters?.[filterType]?.[operator] || [])
    const transformToUppercase = (newValue) => {
        const uppercasedValues = newValue.map((value) =>
            (typeof value === 'string' ? value.toUpperCase() : value)
        )
        return uppercasedValues
    }

    const autocompleteProps = {
        options: ["ADMINISTRATIVA", "CIVEL", "CRIMINAL", "ELEITORAL",
                  "ESPECIAL CIVEL", "ESPECIAL CRIMINAL", "ESPECIAL FAZENDA",
                  "FAZENDA", "PREVIDENCIARIA", "TRABALHISTA", "TRIBUTARIA"],
        limitTags: 2,
        disableCloseOnSelect: true,
        multiple:true,
        value: courtTypes
    }

    return <AutocompleteFilter
            {...props}
            multipleOperators={true}
            transformInput={transformToUppercase}
            setValueState={setCourtTypes}
            autocompleteProps={autocompleteProps}
        />
}

function KeywordFilter(props) {
    const { t } = useTranslation()
    const { rulesList } = props
    const { currentFilter } = props
    const { setNodeState,nodeState } = props
    const { read_only } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [keywords, setKeywords] = useState(nodeState.node.properties.filters?.[filterType]?.[operator]?.values || [])

    const getAvailableLists = () => {
        let availableList = rulesList.lists.filter(list => list.fields[0].type.enum === "string")
        return availableList
    }

    const [listKey, setListKey] = useState(() => {
        const targetListKey = nodeState.node.properties.filters?.[filterType]?.[operator]?.list_key
        if (!targetListKey) return null
        const availableLists = getAvailableLists()
        return availableLists.find(list => list.list_key === targetListKey) || null
    })

    const isWrongOverride = useMemo(() => {
        const isKeywordsEmtpy = (keywords.length === 0)
        const isListKeyEmpty = (listKey === null)
        return isKeywordsEmtpy && isListKeyEmpty
    }, [keywords, listKey])

    const handleListKeyChange = (event, newValue) => {
        setListKey(newValue)
        setNodeState((prevState) => {
            const newNodeState = _.cloneDeep(prevState)
            if (newValue) {
                setObjectByPath(
                    newNodeState.node,
                    `properties.filters.keyword.${operator}.list_key`,
                    newValue.list_key
                )
            } else {
                const operatorFilter = newNodeState.node.properties.filters?.keyword?.[operator]
                if (operatorFilter) {
                    delete operatorFilter.list_key
                }
            }
            return newNodeState
        })
    }

    const autocompleteProps = {
        freeSolo:true,
        limitTags: 2,
        open:false,
        multiple:true,
        value: keywords
    }

    return (<>
            <AutocompleteFilter
                {...props}
                isWrongOverride={isWrongOverride}
                multipleOperators={true}
                setValueState={setKeywords}
                autocompleteProps={autocompleteProps}
            />
            <Autocomplete
                style={{textAlign:"center"}}
                readOnly={read_only}
                fullWidth
                getOptionLabel={(option) => t(option.name)}
                options={getAvailableLists()}
                multiple={false}
                onChange={handleListKeyChange}
                value={listKey}
                renderInput={(params)=>(
                    <TextField
                        {...params}
                        style={{textAlign:"center", margin:"3px auto", width:"80%"}}
                        className="filterTextbox"
                        fullWidth
                        label={t("Escolha uma lista com as Palavras-Chave")}
                        error={isWrongOverride}
                        sx={{
                                '& .MuiInputBase-root': {
                                    justifyContent: 'center',
                                }
                            }}
                        />
                )}
            />
        </>)
}

function LastUpdateFilter(props){
    const { nodeState } = props
    const { currentFilter } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [lastUpdate, setLastUpdate] = useState(nodeState.node.properties.filters?.[filterType]?.[operator] || "")

    const timedeltaProps = {
        value: lastUpdate
    }
    return <TimeDeltaFilter
            {...props}
            multipleOperators={true}
            setValueState={setLastUpdate}
            timedeltaProps={timedeltaProps}
            />

}

function PublicationDateFilter(props){
    const { nodeState } = props
    const { currentFilter } = props
    const filterType = currentFilter.type
    const operator = currentFilter.operator
    const [publicationDate, setPublicationDate] = useState(nodeState.node.properties.filters?.[filterType]?.[operator] || "")

    const timedeltaProps = {
        value: publicationDate
    }
    return <TimeDeltaFilter
            {...props}
            multipleOperators={true}
            setValueState={setPublicationDate}
            timedeltaProps={timedeltaProps}
            />
}

function SecretOfJusticeFilter(props){
    const { t } = useTranslation()
    const { currentFilter } = props
    const { nodeState, setNodeState } = props
    const { activeFilters, setActiveFilters } = props
    const [keepDialogOpen, setKeepDialogOpen] = useState(true)

    const handleDecline = () => {
        setKeepDialogOpen(false)
        setActiveFilters((prev) => prev.map((filter, _) => {
            if(filter.type === currentFilter.type &&
               filter.operator === currentFilter.operator)
                return {type: "choose", operator:"choose"}
            else
                return filter
        }))
    }

    const handleAccept = () => {
        setActiveFilters((prev) => prev.filter((filter, _) => {
            if(filter.type === currentFilter.type &&
               filter.operator === currentFilter.operator)
                return true
            else
                return false
        }))

        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node,`properties.filters`, {"status": {"must": ["DADOS OCULTADOS: SEGREDO DE JUSTIÇA"]}})
        setNodeState(new_node)

        setKeepDialogOpen(false)
    }

    useEffect(() => {
        const needsUpdate = nodeState.node.properties.filters?.status?.must?.[0] !== "DADOS OCULTADOS: SEGREDO DE JUSTIÇA"

        if (activeFilters.length === 1 && needsUpdate) {
            const new_node = _.cloneDeep(nodeState)
            setObjectByPath(
                new_node.node,
                `properties.filters`,
                {"status": {"must": ["DADOS OCULTADOS: SEGREDO DE JUSTIÇA"]}}
            )
            setNodeState(new_node)
        }
    }, [activeFilters, setNodeState, nodeState])

    return(<>
        <ChooseFilterSection {...props}/>
        {<Dialog open={keepDialogOpen && activeFilters.length > 1}
                onClose={handleDecline}
                keepMounted={false}>

            <DialogTitle style={{textAlign:"center"}} className="blueText normalMediumSize">
                {t("Filtrar por processos em segredo de justiça?")}
            </DialogTitle>
            <DialogContent>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        gap: '20px'
                    }}
                >
                    <div className="internalCardContainer normalText dialogInfoSize">
                        {t("Quaisquer filtros presentes serão apagados e substituídos por este filtro.")}
                        <br></br>
                        <strong> {t("Deseja mesmo continuar?")}</strong>
                    </div>

                    <div style={{ display: 'flex', gap: '15px' }}>
                        <div
                            className="button onlyboarder normalText normalMediumSize"
                            onClick={handleDecline}
                        >
                            {t("Não, manter minha configuração atual")}
                        </div>
                        <div
                            className="button standard normalText normalMediumSize"
                            onClick={handleAccept}
                        >
                            {t("Sim, apagar todos os outros filtros")}
                        </div>
                    </div>
                </div>
            </DialogContent>
            </Dialog>}
        </>)
}

function TimeDeltaFilter(props) {
    const { t } = useTranslation()
    const { read_only } = props
    const { setErrors } = props
    const { currentFilter } = props
    const { setValueState } = props
    const { timedeltaProps } = props
    const { nodeState, setNodeState } = props

    const isWrong = useMemo(()=> !timedeltaProps.value || timedeltaProps.value.length === 0, [timedeltaProps.value])

    useEffect(()=>{
        const filterType = currentFilter.type
        const error = {
            type: filterType,
            operator: currentFilter.operator,
            message: t('O filtro "')+t(filterType)+t('" foi adicionado mas não foi preenchido')
        }
        if(isWrong)
            setErrors((prev) => [...prev, error])
        else
            setErrors((prev) => prev.filter((err) => !(err.type === error.type && err.operator === error.operator)))
    }, [isWrong, currentFilter, setErrors, t])


    const handleValueChange = (newValue) => {
        setValueState(newValue)
        const operatorTranslate = {"younger_than": "must"}
        const operator = operatorTranslate[currentFilter.operator]

        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node.properties,`filters.${currentFilter.type}.${operator}`, newValue)
        setNodeState(new_node)
    }

    return (
        <>
            <ChooseFilterSection {...props}/>
            <TimeDeltaTextField
                {...timedeltaProps}
                valueChangeFunction={handleValueChange}
                label={null}
                error={isWrong}
                read_only={read_only}
            />
        </>
    )
}

function AutocompleteFilter(props) {
    const { t } = useTranslation()
    const { read_only } = props
    const { setErrors } = props
    const { currentFilter } = props
    const { setValueState } = props
    const { setNodeState, nodeState } = props
    const { autocompleteProps, transformInput } = props
    const { isWrongOverride } = props;

    const isWrongDefault = useMemo(() => autocompleteProps.value.length === 0, [autocompleteProps.value]);
    const isWrong = useMemo(() => {
        if (currentFilter.type === 'keyword') console.log(`isWrong: ${isWrongOverride ?? isWrongDefault}`)
        return isWrongOverride ?? isWrongDefault
    }, [isWrongDefault, isWrongOverride, currentFilter.type])

    useEffect(() => {
        const filterType = currentFilter.type
        const operator = currentFilter.operator
        const error = {
            type: filterType,
            operator: operator,
            message:t('O filtro "')+t(filterType)+' '+t(operator)+t('" foi adicionado mas não foi preenchido')
        }
        if(isWrong)
            setErrors((prev) => [...prev, error])
        else
            setErrors((prev) => prev.filter((err) => !(err.type === error.type && err.operator === error.operator)))
    }, [isWrong, currentFilter, setErrors, t])

    const handleValueChange = (event, newValue) => {
        const filterType = currentFilter.type
        let transformedValue = newValue
        if(transformInput)
            transformedValue = transformInput(newValue)
        setValueState(transformedValue)

        let new_node = _.cloneDeep(nodeState)
        if (filterType === 'keyword')
            setObjectByPath(new_node.node,`properties.filters.${currentFilter.type}.${currentFilter.operator}.values`, transformedValue)
        else
            setObjectByPath(new_node.node,`properties.filters.${currentFilter.type}.${currentFilter.operator}`, transformedValue)
        setNodeState(new_node)
    }

    const ChipProps= {
            sx: {
                bgcolor: '#0b1f8288',
                color: 'white',
                fontWeight: 'bold',
                '& .MuiChip-deleteIcon': {
                    color: '#ffffffb2',
                },
            }
        }

    return (<>
        <ChooseFilterSection {...props} />
        <Autocomplete
        options={[]}
        ChipProps={ChipProps}
        {...autocompleteProps}
        onChange={handleValueChange}
        style={{textAlign:"center"}}
        getOptionLabel={(option) => t(option)}
        readOnly={read_only}
        fullWidth
        renderInput={(params)=>(
            <TextField
                {...params}
                style={{textAlign:"center", margin:"3px auto", width:"80%"}}
                className="filterTextbox"
                label={t("Adicione itens")}
                fullWidth
                error={isWrong}
                sx={{
                        '& .MuiInputBase-root': {
                            justifyContent: 'center',
                        }
                    }}
                />
        )}
        />
        </>
        )
}

function ChooseFilterSection(props){
    const { t } = useTranslation()
    const { read_only } = props
    const { setErrors } = props
    const { currentFilter } = props
    const { availableFilters } = props
    const { multipleOperators } = props
    const { nodeState, setNodeState } = props
    const { activeFilters, setActiveFilters } = props

    const isWrong = useMemo(() => !currentFilter?.type || currentFilter.type === 'choose', [currentFilter])

    useEffect(() => {
        const filterType = currentFilter.type
        const error = {
            type: filterType,
            operator: currentFilter.operator,
            message: t("Um tipo de filtro deve ser escolhido")
        }
        if(filterType === 'choose')
            setErrors((prev) => [...prev, error])
        else
            setErrors((prev) => prev.filter((err) => !(err.type === error.type && err.operator === error.operator)))
    }, [currentFilter, setErrors, t])

    const changeSelectedFilter = (newFilter) => {
        setActiveFilters((prev) => prev.map((filter, _) => {
            if(filter.type === currentFilter.type &&
               filter.operator === currentFilter.operator)
                return newFilter
            else
                return filter
        }))
    }

    const removeErrors = () => {
        const filterType = currentFilter.type
        const operator = currentFilter.operator
        setErrors((prev) =>
            prev.filter((error)=>
                !(error.type === filterType &&
                    error.operator === operator)
            )
        )
    }

    const clearStaleNodeState = () => {
        const filterType = (currentFilter.type === 'secret_of_justice')? 'status' : currentFilter.type
        const operator = currentFilter.operator
        const values = nodeState.node.properties.filters?.[filterType]?.[operator]
        if(values){
            setNodeState((prev) => {
                const newNode = _.cloneDeep(prev)
                delete newNode.node.properties.filters[filterType][operator]
                if(Object.keys(newNode.node.properties.filters[filterType]).length === 0)
                    delete newNode.node.properties.filters[filterType]
                return newNode
            })
        }
    }

    const passValuesToNewFilter = (newFilter) => {
        const filterType = newFilter.type
        const operator = newFilter.operator
        const values = nodeState.node.properties.filters?.[currentFilter.type]?.[currentFilter.operator]

        let new_node = _.cloneDeep(nodeState)
        if (filterType === 'keyword'){
            if(values.values) setObjectByPath(new_node.node,`properties.filters.${filterType}.${operator}.values`, values.values)
            if(values.list_key) setObjectByPath(new_node.node,`properties.filters.${filterType}.${operator}.list_key`, values.list_key)
        }
        else if(values) setObjectByPath(new_node.node,`properties.filters.${filterType}.${operator}`, values)
        setNodeState(new_node)
    }

    const handleFilterChange = (e, newFilter) => {
        clearStaleNodeState()
        removeErrors()
        changeSelectedFilter(newFilter)
    }

    const handleOperatorChange = (e, newFilter) => {
        passValuesToNewFilter(newFilter)
        handleFilterChange(e, newFilter)
    }

    const handleRemoveFilter = () => {
        const filterType = (currentFilter.type === 'secret_of_justice')? 'status' : currentFilter.type
        const operator = currentFilter.operator
        const values = nodeState.node.properties.filters?.[filterType]?.[operator]
        if(values){
            setNodeState((prev) => {
                const newNode = _.cloneDeep(prev)
                delete newNode.node.properties.filters[filterType][operator]
                if(Object.keys(newNode.node.properties.filters[filterType]).length === 0)
                    delete newNode.node.properties.filters[filterType]
                return newNode
            })
        }
        removeErrors()
        setActiveFilters((prev) => prev.filter((filter, _) => {
            if(filter.type === currentFilter.type &&
               filter.operator === currentFilter.operator)
                return false
            else
                return true
        }))
    }

    const availableOperators = useMemo(() => {
        return [currentFilter, ...allFilters.filter((filter) =>
            filter.type === currentFilter.type &&
            !activeFilters.some((activeFilter) => activeFilter.type === filter.type && activeFilter.operator === filter.operator)
        )]
    }, [currentFilter, activeFilters])

    const locallyAvailableFilters = useMemo(() => {
        const isAlreadyAvailable = !!availableFilters.filter((filter) => filter.type === currentFilter.type).length
        if (currentFilter.type === 'choose' || isAlreadyAvailable)
            return availableFilters
        else
            return([currentFilter, ...availableFilters]
                .sort((a,b) => (a.type < b.type)? -1 : (a.type === b.type)? 0 : 1)
            )
    }
    , [availableFilters, currentFilter])

    return (
        <>
            <div style={{display:"flex", justifyContent:"center", width:"80%", alignItems: "center"}}>
                <Autocomplete
                    options={locallyAvailableFilters || []}
                    value={(currentFilter.type === 'choose')? null : currentFilter}
                    onChange={handleFilterChange}
                    getOptionLabel={(option) => t(option.type)}
                    size="small"
                    readOnly={read_only}
                    fullWidth
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            style={{ textAlign: "center", margin: "3px auto" }}
                            className="filterTextbox"
                            error={isWrong}
                        />
                    )}
                    isOptionEqualToValue={(option, value) => option.type === value.type}
                />
                {multipleOperators &&
                <Autocomplete
                    options={availableOperators}
                    value={currentFilter}
                    onChange={handleOperatorChange}
                    getOptionLabel={(option) => t(option.operator)}
                    size="small"
                    readOnly={read_only}
                    fullWidth
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            style={{ textAlign: "center", margin: "3px auto" }}
                            className="filterTextbox"
                            error={!currentFilter}
                        />
                    )}
                    isOptionEqualToValue={(option, value) => option.operator === value.operator}
                />}
                {!read_only && <div onClick={handleRemoveFilter} style={{cursor:"pointer", margin: "auto", marginLeft: "8px", width: 24, height: 24, color: "#f44336"}}>
                    <DeleteIcon />
                </div>}
            </div>
        </>
    )

}


export class ProcessesBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        let put_error = false
        let alerts = []
        if((node.node.children || []).length !== 0){
            put_error = true
            alerts.push("Este nó não deve possuir filhos")
        }
        if (node.parentNode !== null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido")
            }
        }
        if (!node.node.properties?.limit_exceeded_action){
            put_error = true
            alerts.push("A ação ao atingir o tamanho máximo de análise deve ser especificada")
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        return "number"
    }
}
